import backend, {IDENTITY_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const createAdmin = (input) => {
  const url = `${IDENTITY_API}/user/admin`;
  return backend.post(url, input);
};

const createCaregiver = (input) => {
  const url = `${IDENTITY_API}/user/caregiver`;
  return backend.post(url, input);
};

const getUser = (userRn, loadAuthData) => {
  const queryParam = {
    loadAuthData,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  const url = `${IDENTITY_API}/user/${userRn}?${query}`;
  return backend.get(url);
};

const queryUser = (filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey: lastEvaluatedKey,
  };
  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }
  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }

  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${IDENTITY_API}/user?${query}`;
  return backend.get(url);
};

const deactivateUser = (userRn) => {
  const url = `${IDENTITY_API}/user/${userRn}/deactivate`;
  return backend.post(url);
};

const reactivateUser = (userRn) => {
  const url = `${IDENTITY_API}/user/${userRn}/reactivate`;
  return backend.post(url);
};

const resetPassword = (userRn, newPassword) => {
  const body = {
    newPassword,
  };
  const url = `${IDENTITY_API}/user/${userRn}/password`;
  return backend.post(url, body);
};

export default {
  createAdmin,
  createCaregiver,
  getUser,
  queryUser,
  deactivateUser,
  resetPassword,
  reactivateUser,
};
